import { ACTION_SSO_LOGOUT, ACTION_SSO_TRIGGER_LOGIN } from '../../actions/sso';

const initialState = {
  loggingOut: false,
  loggingIn: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_SSO_LOGOUT:
      return {
        ...state,
        loggingOut: !state.loggingOut,
      };
    case ACTION_SSO_TRIGGER_LOGIN:
      return {
        ...state,
        loggingIn: !state.loggingIn,
      };
    default:
      return state;
  }
};
